import React, { Fragment } from 'react';
import { SummaryCell, BdayContainer } from './style';
import { TruncatedText, Text } from '../../../UI/Text';
import {
    getParticularWeekDay,
    getFormattedDateFromTimestamp,
    getFormattedDateFromMomentObject,
} from '../../../../Utils/timeConvertorHelper';
import { timeFormats } from '../../../../Constants/timeFormats';

export const BirthdaySummary = ({ weekSelected, birthdays, cellWidth, toggleBirthdaysModal, columnDimensions }) => {
    return [...Array(7)].map((arr, index) => {
        const currentCellDate = getParticularWeekDay(weekSelected, index + 1);
        const formattedDate = getFormattedDateFromMomentObject(currentCellDate, timeFormats.MONTH_DAY);
        const bdayMembers = [];

        birthdays.forEach(bday => {
            if (formattedDate === getFormattedDateFromTimestamp(bday.birth, timeFormats.MONTH_DAY))
                bdayMembers.push(bday);
        });

        const isBirthday = bdayMembers.length > 0;
        const isMoreThanOneBirthday = bdayMembers.length > 1;
        const bdaysObject = {
            birthdays: bdayMembers,
            date: getFormattedDateFromMomentObject(currentCellDate, timeFormats.DAY_NAME_DAY_ORDER_MON),
        };

        const width = columnDimensions.length > 0 ? columnDimensions[index].width : null;

        return (
            <SummaryCell
                onClick={() => toggleBirthdaysModal(bdaysObject)}
                key={index}
                height={'40px'}
                width={`${width || cellWidth}px`}
            >
                <BdayContainer isFilled={isBirthday}>
                    {bdayMembers.length > 0 && (
                        <Fragment>
                            <TruncatedText fontSize={10} weight={100} opacity={0.75}>
                                🎉 {bdayMembers[0].fullName}
                                's birthday
                            </TruncatedText>

                            {isMoreThanOneBirthday && (
                                <Text fontSize={10} weight={'bold'} opacity={0.75}>
                                    and {bdayMembers.length - 1} more
                                </Text>
                            )}
                        </Fragment>
                    )}
                </BdayContainer>
            </SummaryCell>
        );
    });
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/BirthdaySummary.js